// extracted by mini-css-extract-plugin
export default {"inputGroup":"FormStyles_inputGroup__Nxtt7","displayGroup":"FormStyles_displayGroup__UanpC"};